import * as React from "react";
import { Text } from "rebass";

// todo: replace with something more beautiful
export const Progress = () => {
  return <Text>Loading...</Text>;
};
